export default __webpack_public_path__ + "static/media/empty-icon.db2bd50c.svg";